import { getSearchParams } from "@dana/Services/Common";
import { createSession } from "@dana/Services/SalesforceSessionService";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { useEffect } from "react";
import { FC } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

interface OwnProps extends WidgetProps {

}

export const SalesforceLogin: FC<OwnProps> = () => {

    const searchParams = getSearchParams();
    const accessToken = searchParams?.get("accessToken");
    const customerNumber = searchParams?.get("customerNumber");

    useEffect(() => {
        async function login() {
            const session = await createSession(accessToken ?? '', customerNumber ?? '');
            window.location.href = "/";
        };
        if (accessToken && accessToken !== '' && customerNumber && customerNumber !== '') {
            login();
        }
        
    }, []);


    return <></>;
}

const widgetModule: WidgetModule = {
    component: SalesforceLogin,
    definition: {
        group: "Common",
        displayName: "Salesforce sso signin",
        fieldDefinitions: [],
    },
};
export default widgetModule;